import * as AWS from "aws-sdk";

AWS.config.update({
  accessKeyId: "AKIAZDDKC3Q2P4EFTIOX",
  secretAccessKey: "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"
});

const s3 = new AWS.S3();

export default s3;
